import { useState, type FormEvent } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormError,
  FormField,
  FormLabel,
  Input,
} from "@navio-maritime/ui";
import { Compass } from "lucide-react";
import { authClient } from "../lib/platform";

// Login surface — signs in against the navio-platform identity plane (F0.2).
export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    const { error: signInError } = await authClient.auth.signInWithPassword({ email, password });
    if (signInError) setError(signInError.message);
    setBusy(false);
  }

  return (
    <div className="grid min-h-dvh place-items-center bg-neutral-950 p-4 text-white">
      <Card className="w-full max-w-md border-neutral-800 bg-card shadow-xl">
        <CardHeader>
          <div className="mb-4 grid size-11 place-items-center rounded-md bg-neutral-900 text-white">
            <Compass size={22} aria-hidden="true" />
          </div>
          <h1 className="text-xl font-semibold text-foreground">NavioPlan</h1>
          <p className="mt-2 text-sm leading-5 text-muted-foreground">Sign in with your Navio account to plan passages, track performance, and produce voyage reports.</p>
        </CardHeader>
        <CardBody>
          <Form onSubmit={onSubmit}>
            <FormField>
              <FormLabel htmlFor="email">Email</FormLabel>
              <Input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </FormField>
            <FormField>
              <FormLabel htmlFor="password">Password</FormLabel>
              <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </FormField>
            {error ? <FormError>{error}</FormError> : null}
            <Button type="submit" variant="primary" fullWidth loading={busy}>Sign in</Button>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
}
